import axios from "axios";
import * as Sentry from "@sentry/vue";
import userService from "../services/user";

export default {
  namespaced: true,
  state: {
    status: "",
    token: "",
    user: {}
  },
  mutations: {
    authRequest(state) {
      state.status = "loading";
    },
    authSuccess(state, { token, user }) {
      state.status = "success";
      state.token = token;
      state.user = user;
    },
    authError(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
    setBillingAddress(state, address) {
      state.user.billing_address = address;
    }
  },
  actions: {
    setUser({ commit }, user) {
      const token = user.authentication_token;

      localStorage.setItem("token", token);
      axios.defaults.headers.common["Authorization"] = `Token token=${token}`;
      Sentry.configureScope(scope => scope.setUser({ email: user.email }));
      commit("authSuccess", { token, user });
    },
    login({ commit, dispatch }, user) {
      return new Promise((resolve, reject) => {
        commit("authRequest");

        userService.login(user)
          .then(resp => {
            dispatch("setUser", resp.data);
            resolve(resp);
          })
          .catch(err => {
            commit("authError");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        localStorage.removeItem("token");
        Sentry.configureScope(scope => scope.setUser(null));
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    getUser({ commit }) {
      return userService.getUser().then(({ data: user }) => {
        const token = localStorage.getItem("token");

        Sentry.configureScope(scope => scope.setUser({ email: user.email }));
        axios.defaults.headers.common["Authorization"] = `Token token=${token}`;
        commit("authSuccess", { token, user });
      });
    },
    confirmPassword({ commit, dispatch }, { password, passwordConfirmation, token, cgu, majority, newsletter }) {
      return userService.resetPassword({
        password,
        "password_confirmation": passwordConfirmation,
        "reset_password_token": token,
        ...cgu && { "accept_cgu": cgu },
        ...typeof newsletter !== undefined && { newsletter }
      }).then(resp => {
        dispatch("setUser", resp.data);
      });
    },
    updateBillingAddress({ commit }, address) {
      return userService.updateBillingAddress(address).then(resp => {
        commit("setBillingAddress", resp.data);
      });
    }
  },
  getters: {
    isLoggedIn: state => !!state.token,
    agent: state => state.user.agent,
    priceTaxe: state => state.user.vat ? "TTC" : "HT"
  }
};
